import {
  IAction,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as Types from './types';

interface IState {
  messageOutgoingList: {
    status: StateStatus | null;
    data: any;
  };
  memberStateExcludeCyprusList: any;
  xmlMessage: {
    status: StateStatus | null;
    data: any;
  };
}

const initialState: IState = {
  messageOutgoingList: {
    status: null,
    data: null,
  },
  memberStateExcludeCyprusList: {
    status: null,
    data: null,
  },
  xmlMessage: {
    status: null,
    data: null,
  },
};

const MessageOutgoingReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_MESSAGE_OUTGOING_LIST:
      return {
        ...state,
        messageOutgoingList: {
          ...state.messageOutgoingList,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.messageOutgoingList.data
              : action.data,
        },
      };
    case Types.SET_MEMBER_STATE_EXCLUDE_CYPRUS:
      return {
        ...state,
        memberStateExcludeCyprusList: {
          status: action.status,
          data: action.data,
        },
      };
    case Types.GET_MESSAGE_OUTGOING_XML:
      return {
        ...state,
        xmlMessage: {
          status: action.status || null,
          data: action.data,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default MessageOutgoingReducer;
